var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21429 3C2.49441 3 1.80402 3.295 1.295 3.8201C0.785969 4.3452 0.5 5.05739 0.5 5.8V14.2C0.5 14.9426 0.785969 15.6548 1.295 16.1799C1.80402 16.705 2.49441 17 3.21429 17H10.6786C11.3984 17 12.0888 16.705 12.5979 16.1799C13.1069 15.6548 13.3929 14.9426 13.3929 14.2V5.8C13.3929 5.05739 13.1069 4.3452 12.5979 3.8201C12.0888 3.295 11.3984 3 10.6786 3H3.21429ZM17.1838 16.3L14.75 13.7893V6.21067L17.1838 3.7C18.0379 2.818 19.5 3.4424 19.5 4.68933V15.3107C19.5 16.5576 18.0379 17.182 17.1838 16.3Z",
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a657ce924f33948440edd618cf47dfe7.svg";
export { ForwardRef as ReactComponent };